export function keys(obj) {
    return (obj && Object.getOwnPropertyNames(obj)) || [];
}
//# sourceMappingURL=keys.js.map